module.exports = __webpack_public_path__ + "img/01_floors.0fa665cb.svg";